class Home2LabTheme {
  constructor() {
    this.bindMobileCart();
    this.bindLetterIntake();
    this.normalizeProductDetails();
  }

  bindMobileCart() {
    const buyBox = document.querySelector('.product__info-container');
    const sticky = document.querySelector('[data-h2l-mobile-cart]');
    if (!buyBox || !sticky || !('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver(([entry]) => {
      sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
    });
    observer.observe(buyBox);

    sticky.querySelector('button')?.addEventListener('click', () => {
      document.querySelector('.product-form__submit')?.click();
    });
  }

  bindLetterIntake() {
    const config = document.querySelector('[data-h2l-letter-intake]');
    if (!config) return;

    let destinations = {};
    try { destinations = JSON.parse(config.textContent); } catch (_) { return; }

    const form = document.querySelector('product-form form');
    const submit = form?.querySelector('[name="add"]');
    if (!form || !submit) return;

    submit.textContent = 'Start your request';
    form.addEventListener('submit', (event) => {
      const variantId = form.querySelector('[name="id"]')?.value;
      const selection = destinations[variantId] || destinations.default;
      const destination = typeof selection === 'string' ? selection : selection?.url;
      if (!destination) return;
      event.preventDefault();
      const intakeUrl = new URL(destination, window.location.origin);
      intakeUrl.searchParams.set('shopify_variant_id', variantId || '');
      if (typeof selection === 'object' && selection.title) {
        intakeUrl.searchParams.set('shopify_variant_title', selection.title);
      }
      window.location.assign(intakeUrl.toString());
    });
  }

  normalizeProductDetails() {
    const details = document.querySelector('.h2l-product-details');
    if (!details) return;

    const instructionsUrl = details.dataset.instructionsUrl;
    if (instructionsUrl) {
      details.querySelectorAll('a[href*="tdlpathology.com"]').forEach((link) => {
        link.href = instructionsUrl;
        link.textContent = 'View Home2Lab kit instructions';
      });
    }

    details.querySelectorAll('img:not([alt])').forEach((image) => {
      image.alt = `${details.dataset.productTitle || 'Home2Lab product'} supporting information`;
    });
  }
}

const bootHome2LabTheme = () => new Home2LabTheme();

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootHome2LabTheme, { once: true });
} else {
  bootHome2LabTheme();
}

document.addEventListener('shopify:section:load', bootHome2LabTheme);
